import { render, staticRenderFns } from "./chaptermissioninfo.vue?vue&type=template&id=bb0a19e8"
import script from "./chaptermissioninfo.vue?vue&type=script&lang=js"
export * from "./chaptermissioninfo.vue?vue&type=script&lang=js"
import style0 from "./chaptermissioninfo.vue?vue&type=style&index=0&id=bb0a19e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports